import React from 'react';

import { Tooltip } from '@vlabs/uikit';

import st from './ListsPreview.module.sass';

export interface ListsPreviewProps {
  items?: string[];
  tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right';
  emptyValue?: React.ReactNode;
}

export function ListsPreview({
  items = [],
  tooltipPlacement = 'bottom',
  emptyValue = '-',
}: ListsPreviewProps): React.JSX.Element {
  if (items.length === 0) {
    return <span className={st.Root}>{emptyValue}</span>;
  }

  const firstListItem = items[0];
  const restCount = items.length - 1;
  const tooltipContent = items.join(', ');

  return (
    <Tooltip
      className={st.TooltipWrap}
      clickable
      tooltipContent={tooltipContent}
      tooltipProps={{ place: tooltipPlacement }}
    >
      <span className={st.Root}>
        <span className={st.First}>{firstListItem}</span>
        {restCount > 0 && <span className={st.Plus}>{`, +${restCount}`}</span>}
      </span>
    </Tooltip>
  );
}
